import ax from 'axios';

import config from '../config';
import { checkRefreshTokenExpired } from '../utils/authorization';
// import { getRandomString } from '../helper/commonFunction';

export const confirmPayment = async payload => {
  let newToken = await checkRefreshTokenExpired();
  if (newToken !== undefined) {
    return new Promise((resolve, reject) => {
      ax({
        method: 'post',
        headers: {
          Authorization: 'Bearer ' + newToken.accessToken,
          'Content-Type': 'application/json',
          // "X-Request-ID": getRandomString(),
        },
        url: `${config.API_URL}/spm/payment/v1/confirm`,
        data: payload,
      })
        .then(res => resolve(res.data))
        .catch(error => reject(error));
    });
  }
};

export const initiatePayment = async payload => {
  let newToken = await checkRefreshTokenExpired();
  if (newToken !== undefined) {
    return new Promise((resolve, reject) => {
      if (newToken !== undefined) {
        ax({
          method: 'post',
          url: `${config.API_URL}/spm/payment/v1/initiate`,
          headers: {
            Authorization: 'Bearer ' + newToken.accessToken,
            'Content-Type': 'application/json',
            // "X-Request-ID": getRandomString(),
          },
          data: payload,
        })
          .then(res => resolve(res.data))
          .catch(error => reject(error));
      }
    });
  }
};

export const resendOTP = async payload => {
  let newToken = await checkRefreshTokenExpired();
  if (newToken !== undefined) {
    return new Promise((resolve, reject) => {
      ax({
        method: 'post',
        headers: {
          Authorization: 'Bearer ' + newToken.accessToken,
          'Content-Type': 'application/json',
        },
        url: `${config.API_URL}/spm/payment/v1/resendOtp`,
        data: payload,
      })
        .then(res => resolve(res.data))
        .catch(error => reject(error));
    });
  }
};

export const verifyOTP = async payload => {
  let newToken = await checkRefreshTokenExpired();
  if (newToken !== undefined) {
    return new Promise((resolve, reject) => {
      ax({
        method: 'post',
        headers: {
          Authorization: 'Bearer ' + newToken.accessToken,
          'Content-Type': 'application/json',
        },
        url: `${config.API_URL}/spm/payment/v1/verifyOTP`,
        data: payload,
      })
        .then(res => resolve(res.data))
        .catch(error => reject(error));
    });
  }
};
